import { range } from '@xhs/yam-beer/utils/arrayUtils'

export const ROOT_KEY = 'root'

export function getLookupkey(index, key) {
  if (index === 0) {
    return ROOT_KEY
  }
  return `${index}-${key}`
}

export function getChildrenForItem(
  childrenState, index, item, idKey
) {
  const lookupKey = getLookupkey(
    index, item[idKey]
  )
  const state = childrenState[lookupKey] || {}
  return state.children || []
}

/**
 * 获取 level 的context
 * @param {number} levelNums 级联选项的级数量
 * @param {*} childrenState cached 的树状数据平摊 state
 * @param {*} value 当前树状分支 value
 * @param {*} identKey 选项的 id 键值
 */
export function getContext(
  levelNums, childrenState, value, identKey = 'id'
) {
  const val = range(levelNums)
    .reduce((acc, index) => {
      // 第一级选项使用 特殊 key
      if (index === 0) {
        acc.push(childrenState[ROOT_KEY])
        return acc
      }
      const levelValue = value[index - 1]
      // 未加载
      if (!levelValue) {
        acc.push(null)
        return acc
      }

      const prev = acc[acc.length - 1]
      // 上级选项未选
      if (!prev || !prev.loaded || !prev.children) {
        acc.push(null)
        return acc
      }
      // levelIndex-levelId
      const lookupKey = getLookupkey(index, levelValue[identKey])
      acc.push(childrenState[lookupKey])
      return acc
    }, [])
  return val
}

/**
 * 在选择选项后加载下一个选项列表
 * @param {number} level 1 index based 的级别
 * @param {*} lookupKey cached 的数据检索 key
 * @param {*} parent
 * @param {*} context
 */
export function loadChildrenAndSet(
  level, lookupKey, parent, context,
) {
  const {
    childrenState,
    levelNums,
    setChildren,
    getTree,
    identKey,
    hasChildren = () => true,
  } = context
  const state = childrenState[lookupKey]
  // 如果已经缓存了
  if (state && state.loaded && !state.error) {
    return Promise.resolve(childrenState[lookupKey])
  }
  // 选择最后一项了
  if (level > levelNums
      || (parent
            && Object.keys(parent) > 1
            && parent[identKey] && !hasChildren(parent))
  ) {
    const overflowVal = {
      level,
      loaded: true,
      error: null,
      children: [],
    }
    setChildren(lookupKey, overflowVal)
    return Promise.resolve(overflowVal)
  }

  // set to loading ...
  setChildren(lookupKey, {
    level,
    loaded: false,
    children: [],
  })

  // try & catch
  return getTree({
    level,
    context: {
      ...(parent || {}),
      // compatible with old data...
      meta: {
        level,
      },
    },
  })
    .then(res => {
      const val = {
        level,
        loaded: true,
        error: null,
        children: res,
      }
      let emptiesChildrenValue = {}
      if (hasChildren) {
        emptiesChildrenValue = res.reduce((acc, item) => {
          if (hasChildren(item)) {
            return acc
          }
          acc[getLookupkey(level, item[identKey])] = {
            level: level + 1,
            loaded: true,
            error: null,
            children: [],
          }
          return acc
        }, {})
      }
      setChildren(lookupKey, val, emptiesChildrenValue)
      return Promise.resolve(val)
    })
    .catch(e => {
      const val = {
        level,
        loaded: true,
        error: e.message || '加载失败',
        children: [],
        retry: () => loadChildrenAndSet({ level, lookupKey, parent }, context),
      }
      setChildren(lookupKey, val)
      return Promise.resolve(val)
    })
}
